// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-btn-footerBtn-b6a19{display:flex;justify-content:flex-end}.footer-btn-footerBtn-b6a19 .footer-btn-confirm-79314,.footer-btn-footerBtn-b6a19 .footer-btn-next-347e4{margin-left:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerBtn": "footer-btn-footerBtn-b6a19",
	"confirm": "footer-btn-confirm-79314",
	"next": "footer-btn-next-347e4"
};
export default ___CSS_LOADER_EXPORT___;
